import { Component, HostBinding, ChangeDetectorRef } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { interval } from 'rxjs';

@Component({
  selector: 'sa-versioning',
  templateUrl: './versioning.component.html',
  styleUrls: ['./versioning.component.scss'],
})
export class VersioningComponent {
  @HostBinding('class') public classes = 'version-warning';
  @HostBinding('class.wrong-version') public isWrongVersion = false;

  constructor(private swUpdate: SwUpdate, private cd: ChangeDetectorRef) {
    if (this.swUpdate.isEnabled) {
      this.swUpdate.checkForUpdate().then();
    }

    interval(30 * 1000).subscribe(() => {
      if (this.swUpdate.isEnabled) {
        this.swUpdate.checkForUpdate().then();
      }
    });

    this.swUpdate.available.subscribe((event) => {
      this.isWrongVersion = true;
      this.cd.markForCheck();
    });
  }

  public reload() {
    location.reload();
  }
}
